import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import orange from '@mui/material/colors/orange';
import { useNavigate } from 'react-router-dom';
import includes from 'lodash/includes';

import { Box, Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useAuthMethod, useAuthUser } from '@crema/hooks/AuthHooks';
import { Fonts } from '@crema/constants/AppEnums';
import { RootState } from '@crema/redux/store';
import IntlMessages from '@crema/helpers/IntlMessages';
import { useJWTAuth } from '@crema/services/auth/JWTAuthProvider';
import { UserType } from '@crema/models/account';
import styled from '@emotion/styled';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import LogoutIcon from '@mui/icons-material/Logout';

type UserInfoProps = {
  color?: string;
};

const AvatarUser = styled.div`
  position: relative;
  display: flex;
  width: 40px;
  height: 40px;
  padding: 10px 2px 10px 2px;
  border-radius: 50%;
  background: white;
  //background: url('/assets/images/avatarProfile.png') 0 0 / cover no-repeat;

  > img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }
`;

const UserInfo: React.FC<UserInfoProps> = ({ color = 'text.secondary' }) => {
  const { logout } = useAuthMethod();
  const navigate = useNavigate();

  // const user = useSelector((state : RootState) => state.user);
  const { user: jwtUser } = useJWTAuth();
  const [user, setUser] = useState<any>();

  const isPodShopUser = user?.channel?.inflowPath === 'POD_SHOP';
  const isNotAblySub = !user?.channel?.isAblySub;
  const isFromPodShopUser = isPodShopUser && isNotAblySub;
  const isSeller = user?.userGroups?.length > 0 && user?.userGroups[0]?.channelUserGroupType === 'CHANNEL_SELLER_GROUP';

  useEffect(() => {
    if (jwtUser) {
      // console.log('jwtUser----', jwtUser);
      const channelId = jwtUser.channel?.channelId;
      if (channelId) {
        document.title = `POD Shop Admin${channelId ? `(${channelId})` : ''}`;
      }
      setUser(jwtUser);
    }
  }, [jwtUser]);

  useEffect(
    () => () => {
      document.title = 'POD Shop Admin';
    },
    [],
  );

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getUserAvatar = () => {
    if (user?.username) {
      return user.username.charAt(0).toUpperCase();
    }
    if (user?.email) {
      return user.email.charAt(0).toUpperCase();
    }
  };

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '16px',
          minHeight: '68px',
          maxHeight: '68px',
          boxSizing: 'border-box',
          width: '280px',
          height: '70px',
          padding: '10px 16px 10px 0px',
          gap: '16px',
          border: '0px 0px 1px 0px',
          background: 'rgba(255, 255, 255, 0.02)',
        }}
      >
        <AvatarUser>
          <img src={'/assets/images/avatarProfile.png'} alt={''} />
        </AvatarUser>
        <Box
          sx={{
            display: 'flex',
            width: '188px',
            height: '100%',
            fontSize: '14px',
            justify: 'space-between',
            alignItems: 'center',
          }}
        >
          {/*{user?.username ?? 'Admin User '}*/}
          <Typography
            sx={{
              display: 'flex',
              width: '164px',
              height: '100%',
              alignItems: 'center',
              wordWrap: 'break-all',
            }}
          >
            {user?.username
              ? `${user?.username} ${user?.channel?.name ? `(${user?.channel?.name})` : ''}`
              : `Admin User`}
          </Typography>
          <ExpandMoreIcon />
        </Box>
      </Box>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {!isSeller && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate('/myPage');
            }}
            sx={{
              width: '130px',
              fontSize: '14px',
            }}
          >
            <ContactPageIcon fontSize={'small'} color="action" sx={{ marginRight: '8px' }} />
            <IntlMessages id={'common.myPage'} />
          </MenuItem>
        )}
        <MenuItem
          onClick={logout}
          sx={{
            width: '130px',
            fontSize: '14px',
          }}
        >
          <LogoutIcon fontSize={'small'} color="action" sx={{ marginRight: '8px' }} />

          <IntlMessages id={'common.logout'} />
        </MenuItem>
      </Menu>
    </>
  );

  /*  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          py: 3,
          px: 3,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        className="user-info-view"
      >
        <Box sx={{ py: 0.5 }}>
          <Avatar
            sx={{
              height: 40,
              width: 40,
              fontSize: 24,
              backgroundColor: orange[500],
            }}
          >
            {getUserAvatar()}
          </Avatar>
        </Box>
        <Box
          sx={{
            width: { xs: 'calc(100% - 62px)', xl: 'calc(100% - 72px)' },
            ml: 4,
            color: color,
          }}
          className="user-info"
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                mb: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: 16,
                fontWeight: Fonts.MEDIUM,
                color: 'inherit',
              }}
              component="span"
            >
              {user?.username ?? 'Admin User '}
            </Box>
            <Box
              sx={{
                ml: 3,
                color: 'inherit',
                display: 'flex',
              }}
            >
              <ExpandMoreIcon />
            </Box>
          </Box>
          <Box
            sx={{
              mt: -0.5,
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: 'inherit',
            }}
          >
            {user?.userGroups?.at(0)?.name}
          </Box>
        </Box>
      </Box>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {isFromPodShopUser && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate('/myPage');
            }}
          >
            <IntlMessages id={'common.myPage'} />
          </MenuItem>
        )}
        <MenuItem onClick={logout}>
          <IntlMessages id={'common.logout'} />
        </MenuItem>
      </Menu>
    </>
  );*/
};

export default UserInfo;
